import { defineComponent } from 'vue'

export default defineComponent({
  name: 'section',
  props: {
    onlyMobile: { type: Boolean, default: false },
  },
  setup (props, { slots }) {
    return () => (
      <div
        class={[
          'mt-8 px-4 flex',
          props.onlyMobile ? 'max-w-lg px-4 mx-auto' : '',
        ]}
      >
        {slots.default?.()}
      </div>
    )
  },
})
